import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle, Divider, Tab, Tabs
} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {useState} from "react";
import {ProjectManagement} from "./changeHistory/ProjectManagement";
import {Logistics} from "./changeHistory/Logistics";
import {RequestOrigin} from "./changeHistory/RequestOrigin";
import {StatusCol} from "./Openings";
import {Link} from "react-router-dom";
import {buildFilterLink} from "../../../../misc/scroller/Filter";
import {inventoryTableName} from "../../../logistics/warehouse/InventoryFrameTable";

export function ChangeHistory(props: {
    opening?: {
        id: number;
        name: string;
    };

    miscProduct?: {
        id: number;
        name: string;
    };

    inventoryRequest?: {
        id: number;
        status: string;
        qty: number;
        inventoryItem?: number;
        kind?: string;
        stocking?: boolean
    };

    onDone(): void;
}) {

    const [tab, setTab] = useState("logistics");
    const ir = props.inventoryRequest;

    return (
        <Dialog2 open onClose={props.onDone}>
            <DialogTitle>
                <div style={{display: "flex", flexDirection: "row"}}>
                    <div style={{flexGrow: 1}}>
                        {props.inventoryRequest ? "Req #" + props.inventoryRequest.id : (props.opening?.name || props.miscProduct?.name)} Change History
                        {ir && <div style={{
                            fontSize: "0.8rem", fontWeight: "normal",
                            lineHeight: "1em",
                        }}>
                            <RequestOrigin inventoryRequest={ir.id} />
                        </div>}
                        {ir && ir.inventoryItem && <div style={{
                            fontSize: "0.8rem", fontWeight: "normal",
                            lineHeight: "1em",
                        }}>
                            <Link to={makeWarehouseLink({
                                kind: ir.kind || "",
                                stocking: !!ir.stocking,
                                inventoryItem: ir.inventoryItem,
                            })}>
                                Warehouse #{ir.inventoryItem}
                            </Link>
                        </div>}
                    </div>
                    {ir && <div style={{fontSize: "0.8rem", fontWeight: "normal", display: "flex", flexDirection: "column", alignItems: "flex-end", paddingLeft: 12}}>
                        <div style={{position: 'relative', paddingLeft: 6, paddingRight: 6, borderRadius: 4, overflow: "hidden"}}>
                            {StatusCol("Status", "status").render(ir)}
                        </div>
                        <div style={{height: 2}} />
                        <div>
                            {ir.qty} qty
                        </div>
                    </div>}
                </div>
            </DialogTitle>
            <DialogContent style={{padding: 0}}>
            <Tabs value={tab} onChange={(e, value) => setTab(value)}>
                    <Tab label="Logistics" value="logistics" />
                    <Tab label="Project Management" value="project" />
                </Tabs>
                <Divider />
                {tab === "logistics" ?
                    <Logistics opening={props.opening?.id} miscProduct={props.miscProduct?.id} inventoryRequest={props.inventoryRequest?.id} /> :
                    <ProjectManagement opening={props.opening?.id} miscProduct={props.miscProduct?.id} />}
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onDone}>Close</Button>
            </DialogActions>
        </Dialog2>
    )
}

function makeWarehouseLink(input: {
    stocking: boolean;
    kind: string;
    inventoryItem: number;
}) {
    if (!input) return "";
    const search = new URLSearchParams();
    search.set("tab", input.stocking ? "stocking" : "non-stocking");
    search.set("tab2", input.kind);

    const s = new URLSearchParams(buildFilterLink({
        tableName: inventoryTableName(input.stocking ? "stocking" : "non-stocking", input.kind as any),
        filter: {
            type: "eq",
            search: {
                "id": input.inventoryItem,
            }
        }
    }));
    for(const [k, v] of s) {
        search.set(k, v);
    }

    return "/logistics/warehouse?" + search.toString();
}